import GalleryCarousel from "../components/GalleryCarousel";
import "../styles/GallerySection.css";

function GallerySection() {
  return (
    <div
      className="container py-5 justify-content-center text-center"
      id="gallery"
    >
      <h2 className="gallery-title pb-3" style={{ fontFamily: "Poppins" }}>
        Ízelítő abból a támogató közösségből, amelyhez te is csatlakozhatsz — ha
        változtatni akarsz az életeden.
      </h2>
      <GalleryCarousel />

      <a href="/contact" className="gallery-btn">
        Belevágok
      </a>
    </div>
  );
}

export default GallerySection;
